"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Effect } from "effect";
import { RpcClient } from "@effect/rpc";
import { featureAnnouncementsUserEq, FeatureAnnouncementsUserRpc } from "@/lib/effect-query";
import { GLOBAL_ANNOUNCEMENT_QUERY_KEYS } from "./use-global-announcement";

// ============================================================================
// Hook
// ============================================================================

export function useMarkAnnouncementSeen() {
  const queryClient = useQueryClient();
  const mutation = useMutation(featureAnnouncementsUserEq.mutationOptions({
    mutationKey: ["feature-announcements", "mark-seen"],
    mutationFn: (announcementId: string) => Effect.gen(function* () {
      const client = yield* RpcClient.make(FeatureAnnouncementsUserRpc);
      return yield* client.markAnnouncementSeen({
        announcementId
      });
    }).pipe(Effect.scoped),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: GLOBAL_ANNOUNCEMENT_QUERY_KEYS.all
      });
    }
  }));
  return {
    markSeen: mutation.mutateAsync,
    isMarking: mutation.isPending
  };
}